import { Swiper } from 'swiper';
import { Navigation, A11y } from 'swiper/modules';
import 'swiper/css';

const sectionPartnersSliders = document.querySelectorAll('section.partners-slider');

document.addEventListener('DOMContentLoaded', () => {
	sectionPartnersSliders.forEach((section) => {
		if (!section.querySelector('.swiper-partners-slider')) {
			return;
		}

		const sectionId = section.getAttribute('id');
		const swiperId = `#${sectionId} .swiper-partners-slider`;
		const swiperElement = document.querySelector(swiperId);
		const amount = parseInt(swiperElement.getAttribute('data-count'), 10);
		const desktopAmount = 4.25;
		const loopSwiper = amount > Math.floor(desktopAmount);

		new Swiper(swiperId, {
			modules: [Navigation, A11y],
			a11y: true,
			grabCursor: true,
			loop: false,
			slidesPerView: 1.5,
			spaceBetween: 16,
			speed: 400,
			keyboard: {
				enabled: true,
			},
			navigation: {
				nextEl: `#${sectionId} .swiper-btn-next`,
			},
			breakpoints: {
				640: {
					slidesPerView: 2.5,
				},
				1024: {
					slidesPerView: desktopAmount,
					spaceBetween: 16,
				},
			},
		});
	});
});
